import { Reducer } from 'redux'
import { AuthActions, AuthType } from '@root-gipro/store/actions'
import { IAuthState } from '@root-gipro/store/interfaces/state'

const initialState: IAuthState = {
	accessToken: localStorage.getItem('access_token'),
	expires_in: 0,
	refresh_token: '',
	user: {
		roleId: localStorage.getItem('roleId') ? Number(localStorage.getItem('roleId')) : null,
		isAdmin: localStorage.getItem('roleId') ? Number(localStorage.getItem('roleId')) <= 10 : null,
		id: Number(localStorage.getItem('userId')) || 0,
		firstname: localStorage.getItem('firstname') || '',
		lastname: localStorage.getItem('lastname') || '',
	},
}

export const authReducer: Reducer<IAuthState, AuthActions> = (state = initialState, action) => {
	switch (action.type) {
		case AuthType.SET_AUTH:
			return {
				...state,
				accessToken: action.access_token,
				expires_in: action.expires_in,
				refresh_token: action.refresh_token
			}

		case AuthType.SET_AUTH_USER: {
			const { roleId } = action.user
			return {
				...state,
				user: {
					...action.user,
					isAdmin: roleId !== null ? roleId <= 10 : null,
				},
			}
		}

		case AuthType.LOGOUT:
			return {
				accessToken: null,
				expires_in: 0,
				user: {
					roleId: null,
					isAdmin: null,
					id: 0,
					firstname: '',
					lastname: '',
				},
			}

		default:
			return state
	}
}
